import { StepEditorProps } from "../useStepEditor";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { Block } from "../../../../components/atoms";
import { prefixForm } from "../../../../utils/FormUtils";
import { useDataSources } from "../../../datasources/hooks/useDataSources";
import { useMemo } from "react";
import { Select } from "@introist/react-foundation/v2";
import { TagAwareInput } from "../../components/TagAwareInput";
import { DataSourceIcon } from "../../../datasources/components/DataSourceIcon";

export const HarvestDeleteTimeEntryStepEditor = ({ form, stepDataPath }: StepEditorProps) => {
  const prefixedForm = prefixForm(form, stepDataPath);

  const { dataSources } = useDataSources();

  const harvestSourceOptions = useMemo(() => {
    if (!dataSources) return [];
    return dataSources
      .filter(ds => ds.sourceType === "harvest")
      .map(s => ({
        key: s.id,
        title: s.name,
        startAdornment: <DataSourceIcon dataSource="harvest" size="small" />
      }));
  }, [dataSources]);

  return (
    <>
      <Block blended compact>
        <StepEditorAccordion title="Connection">
          <StepEditorAccordion.Row label="Data source">
            <Select
              size="small"
              element="button"
              variant="blended"
              style={{ width: "100%" }}
              options={harvestSourceOptions}
              startAdornment={
                prefixedForm.get("datasourceId") ? (
                  <DataSourceIcon dataSource="harvest" size="small" />
                ) : null
              }
              value={prefixedForm.get("datasourceId")}
              onSelect={opt => prefixedForm.set("datasourceId")(opt.key)}
              placeholder="Select data source"
              attachToRef={false}
            />
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>
      <Block blended compact>
        <StepEditorAccordion title="Time entry details">
          <StepEditorAccordion.Row label="External reference">
            <TagAwareInput
              variant="blended"
              size="small"
              value={prefixedForm.get("externalReferenceId")}
              onChange={prefixedForm.set("externalReferenceId")}
            />
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>
    </>
  );
};
